<template>
  <section class="auth-return">
    <popup
      :opened.sync="openData"
      :title="popupGbn === 1 ? 'MMENU-0059' : 'MMENU-0052'"
      @cancel="
        () => {
          menuOpen = false;
        }
      "
    >
      <template #content>
        <article class="contents" v-if="popupGbn === 1">
          <article v-if="isLogin && isPersonalUser">
            <div class="cont-tit">
              <h6>{{ /*로그인 설정*/ $t("MLGI-07-01-02-02") }}</h6>
            </div>
            <ul class="pop-menu-list">
              <li class="pop-menu-item">
                {{ /*간편 인증 번호*/ $t("MLGI-07-01-02-03") }}
                <div class="form-switch">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    :checked="$store.state.auth.createFido.isPincode === '0' ? false : true"
                    @click.prevent="FN001_MenuPopup($event)"
                  />
                  <!-- {{$store.state.auth.createFido.isPincode}} -->
                  <span class="slider round"></span>
                </div>
              </li>
              <li class="pop-menu-item">
                {{ $store.state.native.biometryTypeIos === "faceId" ? $t("MLGI-07-01-02-05") : $t("MLGI-07-01-02-04") }}
                <div class="form-switch">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    :checked="$store.state.auth.createFido.isFingerprint === '0' ? false : true"
                    @click.prevent="FN002_MenuPopup($event)"
                  />
                  <!-- {{$store.state.auth.createFido.isFingerprint}} -->
                  <span class="slider round"></span>
                </div>
              </li>
              <li v-if="$store.state.auth.createFido.isFingerprint !== '0' && $store.state.auth.createFido.svrFidoInfo.out.success.isSimple" class="pop-menu-item">
                {{ $store.state.native.biometryTypeIos === "faceId" ? /* Face ID 이체 사용 */ $t("FIDO-0015") : /* 지문 이체 사용 */ $t("MLGI-07-01-02-06") }}
                <div class="form-switch">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    :checked="$store.state.auth.createFido.svrFidoInfo.out.success.fidoInfo.fngprUseYn === '1' ? true : false"
                    @click.prevent="FN003_MenuPopup($event)"
                  />
                  <span class="slider round"></span>
                </div>
              </li>
            </ul>
          </article>
          <div v-for="(m, i) in selectMenu.children" :key="i">
            <div class="cont-tit">
              <h6>{{ $t(m.title) }}</h6>
            </div>
            <ul class="pop-menu-list">
              <li
                class="pop-menu-item"
                @click="goPage(submenu)"
                v-for="(submenu, j) in m.children"
                :key="j"
                v-show="
                  !(
                    (submenu.name == 'serviceCancelStep1' && isCorporationSubUser) ||
                    (submenu.name == 'changePassword' && isCorporationSubUser) ||
                    (submenu.name == 'motpTest' && 'production|staging'.includes(env))
                  )
                "
              >
                {{ $t(submenu.title) }}
                <i class="icon icon-sm-right-arrow" />
              </li>
            </ul>
          </div>
          <!-- <template v-show="env == 'local' || env == 'development'">
            <div class="cont-tit">
              <h6>TEST MENU</h6>
            </div>
            <ul class="pop-menu-list">
              <li class="pop-menu-item" @click="go('qrCodeTest')">
                QRcode Test
                <i class="icon icon-sm-right-arrow" />
              </li>
            </ul>
          </template>-->
          <template
            v-if="
              isLogin &&
              'NAPASVN1|NAPASVN2|NAPASVN11|NAPASVN12|NAPASVN21|NAPASVN22|PTHAO1101|TUANHAIBAC|QDUNGTB93|DUYHUYNH87'.includes(sessionInfo.userInfo.userIdnfr) &&
              'production|staging'.includes(env)
            "
          >
            <div class="cont-tit">
              <h6>TEST MENU</h6>
            </div>
            <ul class="pop-menu-list">
              <li class="pop-menu-item" @click="goNapas()">
                NapasTest
                <i class="icon icon-sm-right-arrow" />
              </li>
            </ul>
          </template>
          <template v-else-if="isLogin && 'TESTID008|TESID001'.includes(sessionInfo.userInfo.userIdnfr)">
            <div class="cont-tit">
              <h6>TEST MENU</h6>
            </div>
            <ul class="pop-menu-list">
              <li class="pop-menu-item" @click="goCbmnet()">
                CBM-NET2
                <i class="icon icon-sm-right-arrow" />
              </li>
            </ul>
          </template>
        </article>
        <article class="contents" v-else-if="popupGbn === 2">
          <ul class="pop-menu-list">
            <li class="pop-menu-item" @click="goPage(m)" v-for="(m, i) in selectMenu.children" :key="i">
              {{ $t(m.title) }}
              <i class="icon icon-sm-right-arrow" />
            </li>
          </ul>
        </article>
      </template>
    </popup>

    <!-- fido 관련 팝업 [S] ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
    <FidoPopup />
    <!-- fido 관련 팝업 [E] ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■ -->
  </section>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import { mapGetters } from "vuex";
import FidoPopup from "@/components/layout/FidoPopup";

export default {
  components: { FidoPopup },
  computed: {
    ...mapFields(["menuOpen", "menu", "sessionInfo", "siteCode", "addtlInfo"]),
    ...mapGetters(["isLogin", "isCorporationSubUser", "isPersonalUser", "isCorporationUser", "getMenuByLogin"]),
  },
  props: {
    popupGbn: {
      type: Number, //팝업구분 1: 인증센터, 2: 사고신고
    },
  },
  created() {
    this.env = process.env.NODE_ENV;
    this.$log.info("<<< MenyPopup >>> " + "[" + this.env + "]");
  },
  mounted() {
    this.setMenu();
  },
  data() {
    return {
      popupOpened: false,
      openData: true,
      selectMenu: [],
      env: "",
    };
  },
  methods: {
    popupOpen(gbn) {
      this.popupGbn = gbn;
      this.popupOpened = true;
    },
    setMenu() {
      let list = [];
      for (let data of this.getMenuByLogin) {
        if (this.popupGbn === 1 && data.name == "certificationCenter") {
          let tmpList = [];
          for (let child of data.children) {
            if (child.name == "userGuideMotp") {
              if (this.isPersonalUser || !this.isLogin) {
                tmpList.push(child);
              }
            } else if (child.name == "vtnGuideEkyc") {
              if (
                this.isLogin &&
                (this.isPersonalUser || (this.isCorporationUser && this.sessionInfo.userInfo.sbidDstcd === "1" && this.sessionInfo.userInfo.eceptPrcssDstcd == "00"))
              ) {
                tmpList.push(child);
              }
            } else {
              tmpList.push(child);
            }
          }
          list.push({ ...data, children: tmpList });
        } else if (this.popupGbn === 2 && data.name == "reportAccountMmr") {
          //기업 서브 사용자가 메뉴에 접근하면 페이지 접근을 차단하는 화면을 표시함.
          let tmpList = [];
          for (let child of data.children) {
            if (child.name == "reportInternetBankingSuspension") {
              if (!(this.sessionInfo.userInfo.ppsnCoprDstcd === "2" && (this.sessionInfo.userInfo.sbidDstcd === "2" || this.sessionInfo.userInfo.sbidDstcd === "3"))) {
                tmpList.push(child);
              }
            } else {
              tmpList.push(child);
            }
          }
          list.push({ ...data, children: tmpList });
          //list.push(data);
        }
      }
      this.selectMenu = list[0];
    },
    go(menu) {
      this.menuOpen = false;
      this.$router.push({ name: menu });
    },
    goCbmnet() {
      this.menuOpen = false;
      this.$router.push({ name: "cbmnetTrsaccInfoInptReq" });
    },
    goPage(obj) {
      this.menuOpen = false;
      this.$EventBus.$emit("popupClose");
      if (obj.name == "findId") {
        if (this.isLogin) {
          this.$router.push({ name: "findIdByLogin" });
        } else {
          this.$router.push({ name: obj.name });
        }
      } else if (obj.name == "createEkyc" && this.isLogin) {
        if (this.sessionInfo.userInfo.nativYn == "1") {
          this.$router.push({ name: obj.name });
        } else {
          this.$router.push({ name: "createForgnEkycEnter" });
        }
      } else {
        this.$router.push({ name: obj.name });
      }
    },
    /**
     * pincode 클릭시
     */
    FN001_MenuPopup: function (e) {
      if (e.currentTarget.checked === true) {
        // pincode (재)발급
        this.menuOpen = false;
        this.$store.state.simpleLogin.selectedLoginType === "PINCODE";
        this.$router.push({ name: "createFidoPincode" });
      } else {
        // pincode 해제 확인팝업
        this.$store._mutations["auth/manageFido/mut001_manageFido"][0]("pincodeChg");
      }
    },
    /**
     * fingerprint 클릭시
     */
    FN002_MenuPopup: function (e) {
      if (e.currentTarget.checked === true) {
        // fingerprint (재)발급
        this.menuOpen = false;
        this.$store.state.simpleLogin.selectedLoginType === "FINGERPRINT";
        this.$store.dispatch("auth/manageFido/act005_manageFido");
      } else {
        // fingerprint 해제 확인팝업
        this.$store._mutations["auth/manageFido/mut001_manageFido"][0]("fingerprintConfirm");
      }
    },
    /**
     * 지문간편이체 사용여부 클릭시
     */
    FN003_MenuPopup: function (e) {
      if (e.currentTarget.checked === true) {
        this.$store.dispatch("auth/createFido/act020_createFido", "1");
      } else {
        this.$store.dispatch("auth/createFido/act020_createFido", "0");
      }
    },
  },
};
</script>
